import React, { Component } from 'react';
import User from '../components/User/User';
import ReportSharingPanel from '../components/User/ReportSharingPanel';
import MultiplyHeader from '../components/MultiplyHeader/MultiplyHeader';
import { componentContainerStyle, componentContentStyle } from '../constants';
import { observer } from 'mobx-react';
import { Divider, Header } from 'semantic-ui-react';
import TutorialContext from '../pagesv2/Tutorial/TutorialContext';

export class UserProfile extends Component {
    render() {
        const { editUser, companyStore } = this.props;
        return (
            <div style={componentContainerStyle}>
                <MultiplyHeader text="User Profile" />
                <div style={componentContentStyle}>
                    <div data-tour="settings-form">
                        <User {...this.props} />
                        <Divider section />
                        {editUser && companyStore?.company?.liveMeetingsEnabled && <ReportSharingPanel editUser={editUser} />}
                    </div>
                    <Divider section />
                    <Header>Tutorial</Header>
                    <TutorialContext.Consumer>
                        {({ restartTutorial }) => (
                            <button
                                onClick={restartTutorial}
                                style={{
                                    padding: '10px 20px',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    fontFamily: "'Montserrat', sans-serif",
                                    color: '#ffffff',
                                    background: '#0784a7',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                }}
                            >
                                Restart Tutorial
                            </button>
                        )}
                    </TutorialContext.Consumer>
                </div>
            </div>
        );
    }
}

export default observer(UserProfile);